import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "drawer-container"
};
import ThemePicker from './ThemePicker.vue';
import useStore from '@/store';
import { ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Setting',
  setup(__props) {
    const store = useStore();
    const visible = ref(false);
    const theme = ref(store.setting.theme);
    const setting = useStore().setting;
    const tagsView = ref(setting.tagsView);
    const sidebarLogo = ref(setting.sidebarLogo);
    const appNode = document.getElementById('app');
    const themeChange = val => {
      setting.changeSetting({
        theme: val
      });
      appNode?.style.setProperty('--menu-background-color', val);
    };
    function handleClose() {
      visible.value = false;
    }
    function handleOpen() {
      visible.value = true;
    }
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_switch = _resolveComponent("el-switch");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_IEpSetting = _resolveComponent("IEpSetting");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_drawer, {
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => visible.value = $event),
        title: "系统设置",
        "before-close": handleClose
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          "label-position": "right",
          "label-width": "100px",
          style: {
            "max-width": "460px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "主题颜色"
          }, {
            default: _withCtx(() => [_createVNode(ThemePicker, {
              modelValue: theme.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => theme.value = $event),
              type: "theme",
              onChange: themeChange
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "导航标签"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: tagsView.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => tagsView.value = $event),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "LOGO"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_switch, {
              modelValue: sidebarLogo.value,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => sidebarLogo.value = $event),
              class: "drawer-switch"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", {
        class: "setting-btn",
        onClick: handleOpen
      }, [_createVNode(_component_IEpSetting)], 512), [[_vShow, !visible.value]])]);
    };
  }
});